module.exports = __webpack_public_path__ + "static/media/nasscom.2ef497b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/nasscom.png
// module id = 521
// module chunks = 0